import { Tooltip } from "@mui/material";

import styles from "./styles.module.scss";

interface ButtonCanceledProps {
  handleCancelItem: () => void;
}

export function ButtonCanceled({ handleCancelItem }: ButtonCanceledProps) {
  return (
    <Tooltip placement="top" title="Cancelar">
      <button
        type="button"
        className={`${styles.buttonCanceled}`}
        onClick={() => handleCancelItem()}
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18 6L6 18"
            stroke="#fff"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6 6L18 18"
            stroke="#fff"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
    </Tooltip>
  );
}
